import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import Button from "../components/Button.jsx";
import LoadingComponent from "../components/LoadingComponent.jsx";
import useDownloadState from "../api/utilities/useDownloadState.js";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../utils/context/GlobalContextProvider.jsx";
import {AuthenticationApi} from "../api/authority/generated/index";
import toast from "react-hot-toast";
import {useErrorTranslation} from "../api/utilities/translateErrorMessage.js";


export default function ConfirmEmailNotification() {
    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let {context, getAuthorityConfiguration} = useContext(GlobalContext);

    let [state, setDownloading] = useDownloadState();
    let [buttonPressed, setButtonPressed] = useState(false);

    useEffect(() => {

        if (!buttonPressed) {
            return;
        }

        setButtonPressed(false);

        setDownloading(true);
        new AuthenticationApi(getAuthorityConfiguration())
            .resendConfirmationLink({
                resendConfirmEmailInput: {
                    email: context.currentIdentity?.user?.email ?? '',
                }
            })
            .then((r) => {
                toast.success(t('user.confirmation-email-sent'));
            })
            .catch((e) => et(e).then(toast.error))
            .finally(() => setDownloading(false));

    }, [buttonPressed]);

    if (context.currentIdentity === null || context.currentIdentity.user?.emailConfirmed === true) {
        return (<></>);
    }


    return (
        <div role="alert"
             className={
                 "bg-orange-100 dark:bg-orange-200/30 dark:border-transparent border text-orange-600 dark:text-orange-400 border-orange-200"
             }
        >
            <div className="w-full inline-flex px-4 py-2 text-sm">
                <div className="flex w-full justify-between items-center">
                    <div className="flex gap-2">
                        <div><FontAwesomeIcon icon={faCircleInfo}/></div>
                        <div>{t('user.email-not-confirmed')}</div>
                    </div>
                    <div>
                        <LoadingComponent
                            loading={state.downloading}
                        >
                            <Button className={'button-warning-outline'} onClick={() => setButtonPressed(true)}>
                                {t('user.resend-confirmation-email')}
                            </Button>
                        </LoadingComponent>
                    </div>
                </div>
            </div>
        </div>
    );
}